import React, { useEffect, useState, Component } from "react";
import Typography from "@mui/material/Typography";
import { Button, Row, Col, Form, Alert, Modal } from "react-bootstrap";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Link, useHistory } from "react-router-dom";
import Select from "react-select";
import AddIcon from '@mui/icons-material/Add';


//Librerias de la tabla
import { lighten } from "@mui/material/styles";
import withStyles from "@mui/styles/withStyles";
import makeStyles from "@mui/styles/makeStyles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Checkbox, StepButton } from "@mui/material";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";

import CheckRole from "../CheckRole.js";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions.js";

import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";
import Toolbar from "@mui/material/Toolbar";
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import AADService from "../funcionesAuth.js";

//Finaliza las librerias de la tabla

function AlertDismissibleExample({ alerta }) {
  switch (alerta) {
    case 1:
      return <Alert variant="warning">Alerta</Alert>;
      break;
    case 2:
      return <Alert variant="success">Guardó exitosamente</Alert>;
      break;
    case 3:
      return <Alert variant="danger"></Alert>;
      break;
    case 4:
      return <Alert variant="warning">Error al enviar la información</Alert>;
      break;
    case 5:
      return <Alert variant="danger">Error en el servidor</Alert>;
      break;
    case 6:
      return (
        <Alert variant="warning">
          Ya existe una evaluación para el activo seleccionado
        </Alert>
      );
      break;
    default:
      return <p></p>;
      break;
  }
}
//procesos header
const headCellsProcesos = [
  {
    id: "idsubproceso",
    numeric: false,
    disablePadding: true,
    label: "Id subproceso",
  },
  {
    id: "macroproceso",
    numeric: false,
    disablePadding: false,
    label: "Macroproceso",
  },
  { id: "proceso", numeric: false, disablePadding: false, label: "Proceso" },
  {
    id: "subproceso",
    numeric: false,
    disablePadding: false,
    label: "Subproceso",
  },
  { id: "estado", numeric: false, disablePadding: false, label: "Estado" },
];
//Componentes header
const headCells = [
  { id: "ID", numeric: false, disablePadding: true, label: "ID" },
  { id: "nombre", numeric: false, disablePadding: true, label: "Nombre" },
  {
    id: "descripcion",
    numeric: true,
    disablePadding: false,
    label: "Descripción",
  },
];
//////////////////////Tabla dentro del Modal
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHeadProcesos(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCellsProcesos.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
EnhancedTableHeadProcesos.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          padding="checkbox"
          style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              className="label"
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    //paddingLeft: theme.spacing(2),
    //paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.mode === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: "1 1 100%",
  },
}));
//////////////////////Fin Tabla dentro del Modal
const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;
  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Evaluaciones
        </Typography>
      )}
      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton aria-label="delete" size="large">
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Filter list">
          <IconButton aria-label="filter list" size="large">
            <FilterListIcon />
          </IconButton>
        </Tooltip>
      )}
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStylesModal = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    //marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  head: {
    backgroundColor: "#2c2a29",
    color: "#ffffff",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  container: {
    maxHeight: "55vh",
    minHeight: "55vh",
  },
}));
//////////////////////Fin Tabla dentro del Modal

//Empieza tabla de activos
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#2c2a29",

    color: "white",
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: "#f4f4f4",
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

const stylesSelect = {
  control: (base) => ({
    ...base,
    fontFamily: "Roboto",
  }),
  menu: (base) => ({
    ...base,
    fontFamily: "CIBFont Sans Regular",
  }),

  option: (provided, state) => ({
    ...provided,
    //color: state.isFocused ? 'white' : '#495057',
  }),
};

//Finaliza tabla de activos

const NuevosActivos = (props) => {
  const classes = useStyles();
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShowProcesos, setModalShowProcesos] = React.useState(false);
  const [companiaDat, setCompaniaDat] = React.useState([]);
  const check = new CheckRole("/NuevoActivo");
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const [modalInfo, setModalInfo] = React.useState([]);

  const [usuariosDatNeg, setUsuariosDatNeg] = React.useState([]);
  const [usuariosDatTI, setUsuariosDatTI] = React.useState([]);

  const [estadoPOST, setEstadoPost] = React.useState(0);
  let history = useHistory();
  const [validated, setValidated] = useState(false);
  const [clasi, setClasi] = useState([]);
  const [state, setState] = useState("Activo");
  const [idState, setIdState] = useState(true);
  const [vRequired, setVRequired] = useState(false);
  const [nvCriticidad, setNvCriticidad] = useState("No Clasificado");
  //////////////////////////////Selects
  const [companiaSelect, setCompaniaSelect] = useState(null);
  const [responsableTI, setresponsableTI] = useState(null);
  // const [responsableNeg, setresponsableNeg] = useState(null);
  //////////////////////////////datos tablas
  const [rowsc, setRowsC] = React.useState([]);
  const [rowsP, setRowsP] = React.useState([]);
  const [procesosSelected, setProcesosSelected] = React.useState([]);
  const [componentesSelected, setComponentesSelected] = React.useState([]);
  //////////////////////Constante Datos Tabla Modal
  const [modalCompo, setModalCompo] = useState([]);

  const [direccion, setDireccion] = React.useState(false);
  const [datContenidos, setDatContenidos] = React.useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  /////////////////////////////////////
  const [activoUnico, setActivoUnico] = useState(null);
  const [activoAuditable, setActivoAuditable] = useState(null);
  const [atributos, setAtributos] = useState([1, 2, 3, 4, 5]);
  const [valores, setValores] = React.useState({});
  const [valoresPDP, setValoresPDP] = React.useState({});
  const [errors, setErrors] = React.useState({});
  const [dominio, setDominio] = useState("");
  const [errorDominio, setErrorDominio] = useState(false);
  const [errorResponsableTI, setErrorResponsableTI] = useState(false);
  const [nameCompa, setNameCompa] = React.useState("");
  const [errorNombreActivo, setErrorNombreActivo] = useState(false);
  const [errorCompania, setErrorCompania] = useState(false);
  // const [errorResponsableNeg, setErrorResponsableNeg] = useState(false);
  const [errorActivoUnico, setErrorActivoUnico] = useState(false);
  const [errorActivoAuditable, setErrorActivoAuditable] = useState(false);
  const [confidencialidad, setConfidencialidad] = useState(null);
  const [disponibilidad, setDisponibilidad] = useState(null);
  const [integridad, setIntegridad] = useState(null);
  const [selectedValueCompania, setSelectedValueCompania] = useState(null);
  const [selectedValueResponsableTI, setSelectedValueResponsableTI] = useState(null);
  // const [selectedValueResponsableNeg, setSelectedValueResponsableNeg] = useState(null);
  const [errorAplicaciones, setErrorAplicaciones] = useState(false);
  const [opcionesDominio, setOpcionesDominio] = useState([]);
  const eliminarAtributo = (num) => {
    setAtributos((prev) => prev.filter((n) => n !== num));
  };

  const agregarAtributo = () => {
    setAtributos([...atributos, atributos.length + 1]);
  };

  const crear_com = (event) => {
    var button = document.getElementById("send");
    //button.form.submit();
    //alert(button)
    button.click();
    setModalShow(false);
  };


  useEffect(() => {
    const obtenerInformacionCompleta = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL + "evaluacion/infoCompletaActivos/" + "1/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error al obtener la información completa del activo");
        }

        const data = await response.json();

        // 1. Tipos de dominio (opciones del select)
        const opciones = data.tiposActivos.map(item => ({
          value: item.idtipo_activo,
          label: item.tipo_activo,
        }));
        setOpcionesDominio(opciones);
      } catch (error) {
        console.error("Error en obtenerTiposActivos:", error);
      }
    };
    const obtenerComponentes = async () => {
      try {
        const response = await fetch(
          process.env.REACT_APP_API_URL +
          "allcomponents/" +
          localStorage.getItem("idcompania") +
          "/1/" + localStorage.getItem("idusuario") + "/",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Error al obtener los componentes");
        }

        const data = await response.json();
        const resultComponentes = data.filter(dato => dato.estadotipoactivo === true);

        setModalCompo(resultComponentes);
        console.log(modalCompo)

      } catch (error) {
        console.error("Error en obtenerComponentes:", error);
        // Aquí podrías manejar un estado de error o mostrar mensaje al usuario
      }
    };




    const obtenerProceso = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/procesosxCompania/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datProcesos = await result.json();
      setModalInfo(datProcesos);
    };

    const obtenerCompañias = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL + "general/compania/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datCompania = await result.json();
      let companiaSelect = [];

      companiaSelect = datCompania.map(
        ({ idcompania: value, compania: label }) => ({
          value,
          label,
        })
      );
      setCompaniaDat(companiaSelect);
      setNameCompa(companiaSelect);
    };


    const obtenerUsuariosNeg = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "usuariosrolneg/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datUsuarios = await result.json();

      let usuariosNeg = datUsuarios.map(
        ({ idposicion: value, nombre: label }) => ({
          value,
          label,
        })
      );
      setUsuariosDatNeg(usuariosNeg);
    };
    const obtenerUsuariosTI = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "usuariosrolti/" +
        localStorage.getItem("idcompania") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let datUsuarios = await result.json();

      let usuariosTI = datUsuarios.map(
        ({ idposicion: value, nombre: label }) => ({
          value,
          label,
        })
      );;
      setUsuariosDatTI(usuariosTI);
    };
    const obtenerClasi = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "general/parametrosGeneralesxGrupo/activo/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      let data = await result.json();
      setClasi(data);
    };

    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "usuarios/menu/" +
        localStorage.getItem("usuario") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = [];
      let permisos = [];
      for (let i = 0; i < usuario.length; i++) {
        permisos = usuario[i].permisos.split(";");
        opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
      }
      setOpcionesGenerales(opciones);
      var validity = check.checkPermits(opciones, "POST");
      if (validity) {
      }
    };
    obtenerClasi();
    obtenerInformacionCompleta();
    obtenerProceso();
    obtenerUsuariosNeg();
    obtenerUsuariosTI();
    obtenerCompañias();
    obtenerComponentes();
    fetchUsuario();
  }, []);


  const removeTag = (i) => {
    const newTags = [...datContenidos];
    newTags.splice(i, 1);
    setDatContenidos(newTags);
  };

  // const inputKeyDown = (e) => {
  //   const val = e.target.value;
  //   if (e.key === "Enter" && val) {
  //     e.preventDefault();
  //     setValidated(false);
  //     if (
  //       datContenidos.find((tag) => tag.toLowerCase() === val.toLowerCase())
  //     ) {
  //       return;
  //     }
  //     setDatContenidos([...datContenidos, val]);
  //     let inputTag = document.getElementById("datosSeparados");
  //     inputTag.value = null;
  //   } else if (e.key === "Backspace" && !val) {
  //     removeTag(datContenidos.length - 1);
  //   }
  // };


  const MySelect = (props) => (
    <Select
      {...props}
      className='texto'
      options={props.options}
      placeholder={props.placeholder}
    />
  );

  const cambiarCriticidad = (conf, disp, integ) => {
    const getPeso = (valor) => {
      const pesos = {
        "Crítico": 10,
        "Restringida": 10,
        "Confidencial": 7,
        "Moderado": 5,
        "Interna": 5,
        "Tolerable": 3,
        "Bajo": 1,
        "Pública": 1
      };
      return pesos[valor] || null;
    };

    const pesoConfi = getPeso(conf);
    const pesoDispo = getPeso(disp);
    const pesoInte = getPeso(integ);

    if ([pesoConfi, pesoDispo, pesoInte].some(peso => peso === null)) {
      setNvCriticidad("No Clasificado");
      return;
    }

    const temp = pesoConfi * 0.4 + pesoDispo * 0.3 + pesoInte * 0.3;

    if (temp <= 3.9) {
      setNvCriticidad("Activo Soporte");
    } else if (temp <= 6.9) {
      setNvCriticidad("Activo estratégico");
    } else {
      setNvCriticidad("Activo Crítico");
    }
  };

  // const handleChangeState = (event) => {
  //   if (state == "Activo") {
  //     setState("Inactivo");
  //     setIdState(false);
  //   } else {
  //     setState("Activo");
  //     setIdState(true);
  //   }
  // };

  const onChangeResponsableTI = (value) => {
    const id = value?.idposicion || null;
    setresponsableTI(id);
    if (id) {
      setErrorResponsableTI(false);
    }
  };

  // const onChangeResponsableNeg = (value) => {
  //   setresponsableNeg(value.idposicion);
  // };

  const onChangeCompania = (value) => {
    setCompaniaSelect(value.idcompania);
  };

  const sendData = (event) => {
    event.preventDefault();
    let valid = true;
    console.log("Dominio seleccionado:", dominio);
    // Validación
    if (!dominio || !dominio.value) {
      setErrorDominio(true);
      valid = false;
    } else {
      setErrorDominio(false);
    }
    const nombreActivo = document.getElementById("NombreActivo").value.trim();
    if (nombreActivo === "") {
      setErrorNombreActivo(true);
      valid = false;
    } else {
      setErrorNombreActivo(false);
    }
    if (!selectedValueCompania) {
      setErrorCompania(true);
      valid = false;
    } else {
      setErrorCompania(false);
    }
    if (!selectedValueResponsableTI) {
      setErrorResponsableTI(true);
      valid = false;
    } else {
      setErrorResponsableTI(false);
    }
    // if (!selectedValueResponsableNeg) {
    //   setErrorResponsableNeg(true);
    //   valid = false;
    // } else {
    //   setErrorResponsableNeg(false);
    // }
    if (!activoUnico) {
      setErrorActivoUnico(true);
      valid = false;
    } else {
      setErrorActivoUnico(false);
    }
    if (!rowsc || rowsc.length === 0) {
      setErrorAplicaciones(true);
      valid = false;
    } else {
      setErrorAplicaciones(false);
    }


    if (!activoAuditable) {
      setErrorActivoAuditable(true);
      valid = false;
    } else {
      setErrorActivoAuditable(false);
    }
    if (
      confidencialidad &&
      confidencialidad.value !== "" &&
      disponibilidad &&
      disponibilidad.value !== "" &&
      integridad &&
      integridad.value !== ""
    ) {
      setVRequired(false);
      console.log({
        clasificacion_confidencialidad: confidencialidad.value,
        clasificacion_disponibilidad: disponibilidad.value,
        clasificacion_integridad: integridad.value,
      });
    } else {
      setVRequired(true);
      valid = false;
    }
    let erroresAtributos = {};
    atributos.forEach((num) => {
      const atributo = valores[num]?.atributo?.trim() || "";
      const pdp = valoresPDP[num]?.pdp || "";

      if (!atributo || !pdp) {
        valid = false;
        erroresAtributos[num] = {
          atributo: !atributo,
          pdp: !pdp,
        };
      }
    });
    setErrors(erroresAtributos);
    if (!valid) return;

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else if (form.checkValidity() === true) {
      const timeElapsed = Date.now();
      const today = new Date(timeElapsed);
      let componentesAsociadoTemp = [];

      rowsc.forEach((dat) => {
        componentesAsociadoTemp.push({
          idcomponenteasociado: 0,
          idactivo: 0,
          idactivocomponente: dat.idactivo,
          fechacreacion: today.toISOString(),
          estadoasociacion: true,
          idusuariocreacion: parseInt(localStorage.getItem("idusuario")),
          fechamodificacion: today.toISOString(),
          idusuariomodificacion: parseInt(localStorage.getItem("idusuario")),
        });
      });

      let procesosAsociadosTemp = [];
      rowsP.forEach((dat) => {
        procesosAsociadosTemp.push({
          idprocesoasociado: 0,
          idsubproceso: dat.idsubproceso,
          idactivo: 0,
          fechacreacion: today.toISOString(),
          estadoasociacion: true,
          idusuariocreacion: parseInt(localStorage.getItem("idusuario")),
          fechamodificacion: today.toISOString(),
          idusuariomodificacion: parseInt(localStorage.getItem("idusuario")),
        });
      });

      const atributosFormateados = atributos.map(num => ({
        atributo: valores[num]?.atributo || "",
        pdp: valoresPDP[num]?.pdp || ""
      }));

      const data = {
        idactivo: 0,
        idcompania: parseInt(Object.values(selectedValueCompania)[0]),
        idtipo_activo: 1,
        nombre: document.getElementById("NombreActivo").value,
        idposicionresponsableti: parseInt(
          Object.values(selectedValueResponsableTI)[0]
        ),
        idtipo_activo: dominio.value,
        // idposicionresponsablenegocio:
        //   selectedValueResponsableNeg != null
        //     ? parseInt(Object.values(selectedValueResponsableNeg)[0])
        //     : null,
        descripcion: document.getElementById("Descripcion").value,
        estado: idState,
        componente_principal: true ? 1 : 0,
        clasificacion_confidencialidad: !confidencialidad || !confidencialidad.value
          ? null
          : confidencialidad.value,
        clasificacion_integridad: !integridad || !integridad.value
          ? null
          : integridad.value,
        clasificacion_disponibilidad: !disponibilidad || !disponibilidad.value
          ? null
          : disponibilidad.value,
        nivel_criticidad: nvCriticidad,
        fechacreacion: today.toISOString(),
        fechamodificacion: today.toISOString(),
        idusuariocreacion: parseInt(localStorage.getItem("idusuario")),
        idusuariomodificacion: parseInt(localStorage.getItem("idusuario")),
        ComponenteAsociadoAlActivo: componentesAsociadoTemp,
        atributosClasificacion: atributosFormateados
      };

      console.log("ENVIANDO DATA:", data); // <- para depurar

      fetch(process.env.REACT_APP_API_URL + "evaluacion/activoInformacion/" + localStorage.getItem("idcompania") + "/", {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) =>
          response.json().then((res) => {
            if (response.status >= 200 && response.status < 300) {
              setEstadoPost(2);
              localStorage.setItem("idactivo", res.idactivo);
              if (direccion === true) {
                history.push({
                  pathname: "/NuevoComponente",
                  state: "ACI",
                });
              } else if (props.location.state === "COM") {
                history.push("/EditarComponente");
              } else {
                history.push("/EditarActivo");
              }
            } else if (response.status >= 500) {
              setEstadoPost(5);
            } else if (response.status >= 400 && response.status < 500) {
              setEstadoPost(4);
            }
          })
        )
        .catch((err) => {
          console.error("ERROR FETCH:", err);
        });
    }

    setValidated(true);
  }

  ///////////////////////////////////////////////
  //Procesos
  function MyVerticallyCenteredModalProcesos(props) {
    const classes = useStylesModal();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("name");
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [queryText, setqueryText] = React.useState("");
    const [procesosTemp, setProcesosTemp] = React.useState(props.procesos);


    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = modalInfo.map((n) => n.idsubproceso);
        setProcesosTemp(newSelecteds);
        return;
      }
      setProcesosTemp([]);
    };
    const handleClick = (event, idsubproceso) => {
      const selectedIndex = procesosTemp.indexOf(idsubproceso);

      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(procesosTemp, idsubproceso);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(procesosTemp.slice(1));
      } else if (selectedIndex === procesosTemp.length - 1) {
        newSelected = newSelected.concat(procesosTemp.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          procesosTemp.slice(0, selectedIndex),
          procesosTemp.slice(selectedIndex + 1)
        );
      }
      setProcesosTemp(newSelected);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };
    const isSelected = (idsubproceso) =>
      procesosTemp.indexOf(idsubproceso) !== -1;
    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, modalInfo.length - page * rowsPerPage);



    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="subtitulo" id="contained-modal-title-vcenter">
            Añadir Procesos asociados al activo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar"
                    onChange={(e) => setqueryText(e.target.value)}
                    style={{ align: "center" }}
                  />
                </Form>
              </Col>
              {/* <Col sm={4} xs={6}>
                <Link to="NuevoComponente">
                  <Button
                    className="botonPositivo"
                    style={{ marginTop: "1%", width: "100%" }}
                  >
                    {" "}
                    Nuevo{" "}
                  </Button>
                </Link>
              </Col> */}
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => {
                    completarTabla(procesosTemp, "procesos");
                  }}
                >
                  {" "}
                  Guardar{" "}
                </Button>
              </Col>
            </Row>
            <Paper className={classes.paper}>
              <TableContainer className={classes.container}>
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  aria-label="enhanced table"
                >
                  <EnhancedTableHeadProcesos
                    classes={classes}
                    numSelected={procesosTemp.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={modalInfo.length}
                  />
                  <TableBody>
                    {stableSort(modalInfo, getComparator(order, orderBy))
                      .filter((row) =>
                        row.idsubproceso
                          .toLowerCase()
                          .includes(queryText.toLowerCase())
                      )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idsubproceso);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            onClick={(event) =>
                              handleClick(event, row.idsubproceso)
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idsubproceso}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </TableCell>
                            <TableCell
                              component="th"
                              id={labelId}
                              scope="row"
                              padding="none"
                            >
                              {row.idsubproceso}
                            </TableCell>
                            <TableCell align="left">
                              {row.macroproceso}
                            </TableCell>
                            <TableCell align="left">{row.proceso}</TableCell>
                            <TableCell align="left">{row.subproceso}</TableCell>
                            <StyledTableCell align="center">
                              <Checkbox
                                inputProps={{ "aria-label": "Checkbox A" }}
                                checked={row.estado}
                              />
                            </StyledTableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={modalInfo.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={"Filas por página"}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Vista compacta"
            />
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  ///////// Componentes
  function MyVerticallyCenteredModal(props) {
    const classes = useStylesModal();
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("name");
    const [page, setPage] = React.useState(0);
    const [dense, setDense] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [queryText, setqueryText] = React.useState("");
    const [contTecno, setContTecno] = React.useState(props.componentes);


    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(property);
    };
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = modalCompo.map((n) => n.idevaluacion);
        setContTecno(newSelecteds);
        return;
      }
      setContTecno([]);
    };
    const handleClick = (event, id, idtipo_activo, obj) => {
      const selectedIndex = contTecno.indexOf(id);
      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(contTecno, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(contTecno.slice(1));
      } else if (selectedIndex === contTecno.length - 1) {
        newSelected = newSelected.concat(contTecno.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          contTecno.slice(0, selectedIndex),
          contTecno.slice(selectedIndex + 1)
        );
      }
      setContTecno(newSelected);
    };
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
    const handleChangeDense = (event) => {
      setDense(event.target.checked);
    };
    const isSelected = (id) => contTecno.indexOf(id) !== -1;
    const emptyRows =
      rowsPerPage -
      Math.min(rowsPerPage, modalCompo.length - page * rowsPerPage);

    function cprincipal(componente_principal) {
      if (componente_principal === 1) {
        return "Principal";
      } else if (componente_principal === 2) {
        return "Módulo";
      } else if (componente_principal === 3) {
        return "Infraestructura";
      } else {
        return "Valor no reconocido";
      }
    }

    //Retorna el nombre de la compañía segun id
    function bCompania(id) {
      for (const clave in nameCompa) {
        if (id == nameCompa[clave]["idcompania"]) {
          return nameCompa[clave]["compania"];
        }
      }
      return "No Existe";
    }




    return (
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="subtitulo" id="contained-modal-title-vcenter">
            Añadir elementos tecnológicos asociados al activo
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.root}>
            <Row>
              <Col sm={4} xs={2}>
                <Form className="buscar">
                  <Form.Control
                    type="text"
                    placeholder="Buscar"
                    onChange={(e) => setqueryText(e.target.value)}
                  />
                </Form>
              </Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonPositivo"
                  onClick={(e) => crear_com(e)}
                  style={{ marginTop: "1%", width: "100%" }}
                >
                  Crear
                </Button>
              </Col>
              <Col sm={4} xs={6}>
                <Button
                  className="botonGeneral"
                  style={{ marginTop: "1%", width: "100%" }}
                  onClick={() => {
                    completarTabla(contTecno, "detalles");
                    setDireccion(false);
                  }}
                >
                  Guardar
                </Button>
              </Col>
            </Row>

            <Paper className={classes.paper}>
              <TableContainer
                component={Paper}
                className={classes.container}
                style={{ overflowX: "auto" }}
              >
                <Table
                  stickyHeader
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  maxHeightBody="55vh"
                  aria-label="enhanced table"
                >
                  <TableHead>
                    <TableRow className={classes.head}>
                      <StyledTableCell padding="checkbox"></StyledTableCell>
                      <StyledTableCell>Id Activo</StyledTableCell>
                      <StyledTableCell>Clase app</StyledTableCell>
                      <StyledTableCell>Código app</StyledTableCell>
                      <StyledTableCell>Nombre</StyledTableCell>
                      <StyledTableCell>Nombre CMD</StyledTableCell>
                      <StyledTableCell>Compañía</StyledTableCell>
                      <StyledTableCell>Tipo de elemento</StyledTableCell>
                      <StyledTableCell>Descripción</StyledTableCell>
                      <StyledTableCell>Responsable </StyledTableCell>
                      {/* <StyledTableCell>Responsable Negocio</StyledTableCell> */}
                      <StyledTableCell>Fecha Creación</StyledTableCell>
                      <StyledTableCell>Fecha actualización</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {modalCompo
                      .filter((row) =>
                        row.nombre?.toLowerCase().includes(queryText.toLowerCase()) ||
                        row.idactivo?.toString().includes(queryText.toLowerCase())
                      )
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        const isItemSelected = isSelected(row.idactivo);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <TableRow
                            hover
                            onClick={(event) =>
                              handleClick(event, row.idactivo, row.idtipo_activo, row)
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.idactivo}
                            selected={isItemSelected}
                          >
                            <StyledTableCell padding="checkbox">
                              <Checkbox
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                              />
                            </StyledTableCell>
                            <StyledTableCell>{row.idactivo}</StyledTableCell>
                            <StyledTableCell>{row.clase_app}</StyledTableCell>
                            <StyledTableCell>{row.elemento_configuracion}</StyledTableCell>
                            <StyledTableCell>{row.nombre}</StyledTableCell>
                            <StyledTableCell>{row.nombrecmdb}</StyledTableCell>
                            <StyledTableCell>{bCompania(row.idcompania)}</StyledTableCell>
                            <StyledTableCell>{cprincipal(row.componente_principal)}</StyledTableCell>
                            <StyledTableCell>{row.tipo_elemento}</StyledTableCell>
                            <StyledTableCell>{row.descripcion}</StyledTableCell>
                            <StyledTableCell>{row.UsuarioResponsableTI}</StyledTableCell>
                            {/* <StyledTableCell>{row.UsuarioResponsableNegocio}</StyledTableCell> */}
                            <StyledTableCell>{row.fechacreacion}</StyledTableCell>
                            <StyledTableCell>{row.fechamodificacion}</StyledTableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                count={modalCompo.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
  //TODO: completar función para encontrar con ID obeto y llenar tabla
  const completarTabla = (obj, id) => {
    let temp = [];

    switch (id) {
      case "procesos":
        setProcesosSelected(obj);
        for (let i = 0; i < obj.length; i++) {
          temp.push(
            modalInfo.filter((dato) => dato.idsubproceso === obj[i])[0]
          );
        }
        setRowsP(temp);
        setModalShowProcesos(false);
        break;
      case "detalles":
        setComponentesSelected(obj);
        for (let i = 0; i < obj.length; i++) {
          temp.push(modalCompo.filter((dato) => dato.idactivo === obj[i])[0]);
        }
        setRowsC(temp);
        setModalShow(false);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <AlertDismissibleExample alerta={estadoPOST} />
      <MyVerticallyCenteredModal
        componentes={componentesSelected}
        show={modalShow}
        onHide={() => {
          setDireccion(false);
          setModalShow(false);
        }}
      />
      <MyVerticallyCenteredModalProcesos
        procesos={procesosSelected}
        show={modalShowProcesos}
        onHide={() => setModalShowProcesos(false)}
      />

      <Row>
        <Col>
          {" "}
          <h2 className="subtitulo">Nuevo Activo de Información</h2>
          <hr />
        </Col>
      </Row>

      <Form
        id="formData"
        onSubmit={(e) => sendData(e)}
        noValidate
        validated={validated}
      >
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label forn-label">Id Activo de Información</label>
          </Col>
          <Col sm={8} xs={12}>
            <input
              type="text"
              disabled
              className="form-control text-center"
              placeholder="ID Automático"
              id="IDactivo"
            ></input>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Información de Dominio*</label>
          </Col>
          <Col sm={8} xs={10}>
            <Form.Group>
              <MySelect
                classNamePrefix="react-select"
                className={errorDominio ? "react-select is-invalid" : "react-select"}
                placeholder="Seleccione un Dominio..."
                options={opcionesDominio}
                name="Dominio"
                id="dominio"
                value={dominio}
                onChange={(e) => {
                  setDominio(e);
                  setErrorDominio(false);
                }}
              />
              {errorDominio && (
                <Form.Control.Feedback type="invalid" className="d-block">
                  Por favor seleccione un Dominio
                </Form.Control.Feedback>
              )}

            </Form.Group>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">
              Nombre Activo de Información*
            </label>
          </Col>
          <Col sm={8} xs={12}>
            <input
              type="text"
              className={`form-control text-center ${errorNombreActivo ? "is-invalid" : ""
                }`}
              placeholder="Nombre del Activo"
              required
              id="NombreActivo"
            />
            <Form.Control.Feedback type="invalid">
              Por favor introduzca un nombre.
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Descripción</label>
          </Col>
          <Col sm={8} xs={12}>
            <textarea
              className="form-control text-center"
              placeholder="Descripción del activo de información"
              rows="3"
              id="Descripcion"
            ></textarea>
          </Col>
        </Row>
        <Row className="mb-3">
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Compañía*</label>
          </Col>
          <Col sm={8} xs={10}>
            <MySelect
              placeholder={"Seleccione la compañía..."}
              options={companiaDat}
              value={selectedValueCompania}
              onChange={(e) => {
                onChangeCompania(e); // función para manejar el cambio (ej. actualizar estado general)
                setErrorCompania(false); // limpio el error
                setSelectedValueCompania(e); // actualizo el estado local para la selección
              }}
              styles={stylesSelect}
              className={errorCompania ? "is-invalid" : ""}
              classNamePrefix="react-select"
            />
            {errorCompania && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione una compañía.
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">
              Responsable
            </label>
          </Col>
          <Col sm={8} xs={10}>
            <div className={errorResponsableTI ? "is-invalid" : ""}>
              <MySelect
                placeholder={"Seleccione el responsable..."}
                options={usuariosDatTI}
                value={selectedValueResponsableTI}
                onChange={(e) => {
                  onChangeResponsableTI(e);
                  setSelectedValueResponsableTI(e);
                  setErrorResponsableTI(false);
                }}
                styles={stylesSelect}
                classNamePrefix="react-select"
              />
            </div>
            {errorResponsableTI && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione un responsable.
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">
              Protección de Datos Personales
            </label>
          </Col>
          <Col sm={8} xs={10}>
            <MySelect
              placeholder="Seleccione..."
              options={[
                { value: "SI", label: "SI" },
                { value: "NO", label: "NO" }
              ]}
            />
          </Col>
        </Row>

        {/* <Row className="mb-3">
          <Col sm={4} xs={12}>
            <label className="label form-label">Responsable del negocio</label>
          </Col>
          <Col sm={8} xs={10}>
            <div className={errorResponsableNeg ? "is-invalid" : ""}>
              <MySelect
                placeholder={"Seleccione el responsable..."}
                options={usuariosDatNeg}
                value={selectedValueResponsableNeg}
                onChange={(e) => {
                  onChangeResponsableNeg(e);
                  setSelectedValueResponsableNeg(e);
                  setErrorResponsableNeg(false);
                }}
                styles={stylesSelect}
                classNamePrefix="react-select"
              />
            </div>
            {errorResponsableNeg && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione un responsable.
              </Form.Control.Feedback>
            )}
          </Col>
        </Row> */}

        <Row className="mb-3 align-items-center">
          <Col sm={4} xs={15}>
            <label className="label form-label fs-3">
              ¿El activo es único en tu Dominio de información?*
            </label>
          </Col>
          <Col sm={4} xs={12}>
            <div className={errorActivoUnico ? "is-invalid" : ""}>
              <Select
                placeholder="Seleccione SI/NO"
                options={[
                  { value: "SI", label: "SI" },
                  { value: "NO", label: "NO" },
                ]}
                name="activoUnico"
                id="activoUnico"
                styles={stylesSelect}
                onChange={(selected) => {
                  setActivoUnico(selected);
                  setErrorActivoUnico(false);
                }}
                classNamePrefix="react-select"
              />
            </div>
            {errorActivoUnico && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione SI/NO
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>

        <Row className="mb-3 align-items-center">
          <Col sm={4} xs={15}>
            <label className="label form-label fs-3">
              ¿El activo es completo y auditable?*
            </label>
          </Col>
          <Col sm={4} xs={12}>
            <div className={errorActivoAuditable ? "is-invalid" : ""}>
              <Select
                placeholder="Seleccione SI/NO"
                options={[
                  { value: "SI", label: "SI" },
                  { value: "NO", label: "NO" },
                ]}
                name="activoAuditable"
                id="activoAuditable"
                styles={stylesSelect}
                onChange={(selected) => {
                  setActivoAuditable(selected);
                  setErrorActivoAuditable(false);
                }}
                classNamePrefix="react-select"
              />
            </div>
            {errorActivoAuditable && (
              <Form.Control.Feedback type="invalid" className="d-block">
                Por favor seleccione SI/NO
              </Form.Control.Feedback>
            )}
          </Col>
        </Row>


        <Row className="mb-3">
          <Col sm={4} xs={5}>
            <label className="label form-label">Clasificación confidencialidad</label>
          </Col>
          <Col sm={2} xs={5}>
            <MySelect
              inputId="Confidencialidad"
              placeholder="Selecciones Clasificación"
              options={[
                { value: "No clasificado", label: "No Clasificado" },
                { value: "Restringida", label: "Restringida" },
                { value: "Confidencial", label: "Confidencial" },
                { value: "Interna", label: "Interna" },
                { value: "Pública", label: "Pública" },
              ]}
              value={confidencialidad}
              onChange={(val) => {
                setConfidencialidad(val);
                const confi = val?.value || "";
                const dispo = disponibilidad?.value || "";
                const inte = integridad?.value || "";
                cambiarCriticidad(confi, dispo, inte);

                if ((confi && dispo && inte) || (!confi && !dispo && !inte)) {
                  setVRequired(false);
                } else {
                  setVRequired(true);
                }
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor:
                    vRequired && (!confidencialidad || confidencialidad.value === "")
                      ? "red"
                      : base.borderColor,
                }),
              }}
            />
            {vRequired && (!confidencialidad || confidencialidad.value === "") && (
              <div style={{ color: "red", fontSize: "0.8rem", marginTop: 4 }}>
                Por favor seleccione un valor válido para confidencialidad
              </div>
            )}
          </Col>

          <Col sm={3} xs={5} className="text-left">
            <label className="label form-label">Clasificación disponibilidad</label>
          </Col>
          <Col sm={3} xs={5}>
            <MySelect
              inputId="Disponibilidad"
              placeholder="Selecciones Clasificación"
              options={[
                { value: "No clasificado", label: "No Clasificado" },
                { value: "Crítico", label: "Crítico" },
                { value: "Moderado", label: "Moderado" },
                { value: "Tolerable", label: "Tolerable" },
                { value: "Bajo", label: "Bajo" },
              ]}
              value={disponibilidad}
              onChange={(val) => {
                setDisponibilidad(val);
                // Usar el nuevo valor directamente
                const confi = confidencialidad?.value || "";
                const dispo = val?.value || "";
                const inte = integridad?.value || "";
                cambiarCriticidad(confi, dispo, inte);

                if ((confi && dispo && inte) || (!confi && !dispo && !inte)) {
                  setVRequired(false);
                } else {
                  setVRequired(true);
                }
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor:
                    vRequired && (!disponibilidad || disponibilidad.value === "")
                      ? "red"
                      : base.borderColor,
                }),
              }}
            />
            {vRequired && (!disponibilidad || disponibilidad.value === "") && (
              <div style={{ color: "red", fontSize: "0.8rem", marginTop: 4 }}>
                Por favor seleccione un valor válido para disponibilidad
              </div>
            )}
          </Col>
        </Row>

        <Row className="mb-3">
          <Col sm={4} xs={5}>
            <label className="label form-label">Clasificación integridad</label>
          </Col>
          <Col sm={2} xs={5}>
            <MySelect
              inputId="Integridad"
              placeholder="Selecciones Clasificación"
              options={[
                { value: "No clasificado", label: "No Clasificado" },
                { value: "Crítico", label: "Crítico" },
                { value: "Moderado", label: "Moderado" },
                { value: "Tolerable", label: "Tolerable" },
                { value: "Bajo", label: "Bajo" },
              ]}
              value={integridad}
              onChange={(val) => {
                setIntegridad(val);
                const confi = confidencialidad?.value || "";
                const dispo = disponibilidad?.value || "";
                const inte = val?.value || "";
                cambiarCriticidad(confi, dispo, inte);

                if ((confi && dispo && inte) || (!confi && !dispo && !inte)) {
                  setVRequired(false);
                } else {
                  setVRequired(true);
                }
              }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderColor:
                    vRequired && (!integridad || integridad.value === "")
                      ? "red"
                      : base.borderColor,
                }),
              }}
            />
            {vRequired && (!integridad || integridad.value === "") && (
              <div style={{ color: "red", fontSize: "0.8rem", marginTop: 4 }}>
                Por favor seleccione un valor válido para integridad
              </div>
            )}
          </Col>

          <Col sm={3} xs={5} className="text-left">
            <label className="label form-label">Nivel de criticidad</label>
          </Col>
          <Col sm={3} xs={5} className="d-flex align-items-center">
            <input
              disabled
              type="text"
              className="form-control text-center colorAuto"
              placeholder="Calculado Automático"
              id="Criticidad"
              value={nvCriticidad}
            />
          </Col>
        </Row>


        <div className="border rounded p-3 bg-light mb-4">
          {/* Título principal */}
          <Row className="mb-3 align-items-center">
            <Col className="d-flex align-items-center gap-2">
              <label className="label form-label mb-0">Atributos*</label>
            </Col>
          </Row>

          {/* Encabezados de columnas */}
          <Row className="mb-2">
            <Col sm={3} xs={12}></Col>
            <Col sm={4} xs={12}>
              <label className="form-label fw-bold">Nombre del atributo</label>
            </Col>
            <Col sm={4} xs={12}>
              <label className="form-label fw-bold">Protección Datos Personales</label>
            </Col>
            <Col sm={1}></Col>
          </Row>

          {/* Campos dinámicos */}
          {atributos.map((num) => (
            <Row className="mb-3" key={`atributo-${num}`}>
              <Col sm={3} xs={12}>
                <label className="label form-label">{`Atributo ${num}`}</label>
              </Col>

              <Col sm={4} xs={12}>
                <input
                  type="text"
                  className={`form-control ${errors[num]?.atributo ? "is-invalid" : ""}`}
                  placeholder={`Nombre del atributo ${num}`}
                  id={`atributoNombre${num}`}
                  name={`atributoNombre${num}`}
                  value={valores[num]?.atributo || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValores(prev => ({
                      ...prev,
                      [num]: {
                        ...prev[num],
                        atributo: value,
                      }
                    }));
                  }}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  Por favor escribe el nombre del Atributo
                </Form.Control.Feedback>
              </Col>

              <Col sm={4} xs={12}>
                <select
                  className={`form-control ${errors[num]?.pdp ? "is-invalid" : ""}`}
                  id={`pdp${num}`}
                  name={`pdp${num}`}
                  value={valoresPDP[num]?.pdp || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setValoresPDP(prev => ({
                      ...prev,
                      [num]: {
                        ...prev[num],
                        pdp: value,
                      }
                    }));
                  }}
                  required
                >
                  <option value="">Seleccione</option>
                  <option value="1">SI</option>
                  <option value="0">NO</option>
                </select>
                <Form.Control.Feedback type="invalid">
                  Por favor seleccione SI/NO
                </Form.Control.Feedback>
              </Col>



              {num > 5 && (
                <Col sm={1} xs={12} className="d-flex align-items-center">
                  <Button
                    type="button"
                    variant="danger"
                    size="sm"
                    onClick={() => eliminarAtributo(num)}
                  >
                    Eliminar
                  </Button>
                </Col>
              )}

            </Row>
          ))}

          <Row>
            <Col>
              <Button
                type="button"
                className="botonPositivo"
                onClick={agregarAtributo}
              >
                <AddIcon fontSize="small" /> Agregar atributo
              </Button>
            </Col>
          </Row>
        </div>
        <Row className='mb-3'>
          <Col md={10}>
            <h3 style={{ color: errorAplicaciones ? '#dc3545' : 'inherit' }}>
              Aplicaciones asociadas al activo de información
              {errorAplicaciones && <span style={{ color: '#dc3545' }}> *</span>}
            </h3>
            {errorAplicaciones && (
              <div style={{ color: '#dc3545', fontSize: '0.875em', marginTop: '5px' }}>
                Debe agregar al menos una aplicación asociada
              </div>
            )}
          </Col>
          <Col md={2}>
            <Button className='botonIngreso' onClick={() => setModalShow(true)}>
              Añadir
            </Button>
          </Col>
        </Row>

        <Row className='mb-3'>
          <TableContainer
            component={Paper}
            className='table table-bordered'
            style={{
              border: errorAplicaciones ? '2px solid #dc3545' : 'inherit',
              borderRadius: '4px'
            }}
          >
            <Table className={classes.table} aria-label='customized table'>
              <TableHead>
                <TableRow>
                  <StyledTableCell align='left'>ID</StyledTableCell>
                  <StyledTableCell align='left'>Nombre</StyledTableCell>
                  <StyledTableCell align='left'>Tipo de Componente</StyledTableCell>
                  <StyledTableCell align='center'>Fecha modificación</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsc.length === 0 ? (
                  <StyledTableRow>
                    <StyledTableCell colSpan={4} align='center' style={{
                      color: errorAplicaciones ? '#dc3545' : '#6c757d',
                      fontStyle: 'italic',
                      padding: '20px'
                    }}>
                      {errorAplicaciones
                        ? 'No hay aplicaciones asociadas. Debe agregar al menos una.'
                        : 'No hay aplicaciones asociadas'
                      }
                    </StyledTableCell>
                  </StyledTableRow>
                ) : (
                  rowsc.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell component='th' scope='row'>
                        {row.idcomponente == undefined
                          ? row.idactivo
                          : row.idcomponente}
                      </StyledTableCell>
                      <StyledTableCell align='left'>
                        {row.componenteprincipal == !null
                          ? row.nombrecomponente
                          : row.nombre}
                      </StyledTableCell>
                      <StyledTableCell align='left'>
                        {row.componenteprincipal == true ||
                          row.componenteprincipal == undefined
                          ? "Principal"
                          : "Infraestructura"}
                      </StyledTableCell>
                      <StyledTableCell align='center'>
                        {row.fechamodificacion}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Row>
        <Row className="mb-3 ">
          <Col sm={4} xs={1}></Col>
          <Col sm={3} xs={3}>
            {" "}
            {/* <a href="EditarActivo"> */}
            {check.checkPermits(opcionesGenerales, "POST") ? (
              <Button type="submit" className="botonPositivo" id="send">
                Guardar
              </Button>
            ) :
              (
                ""
              )}
            {/* </a> */}
          </Col>
          <Col sm={3} xs={3}>
            {" "}
            <Link to="dominio-de-informacion">
              <Button type="button" className="botonNegativo">
                Descartar
              </Button>
            </Link>
          </Col>
        </Row>
        <hr />
        <Row className="mb-3">
          <Col>
            <br />
          </Col>
        </Row>


        {/* <Row className="mb-3">
          <Col md={10}>
            <h3 className="subtitulo">Procesos asociados al activo ​</h3>
          </Col>
          <Col md={2}>
            <Button
              className="botonIngreso"
              onClick={() => setModalShowProcesos(true)}
            >
              Añadir
            </Button>{" "}
          </Col>
        </Row>
        <Row className="mb-3">
          <TableContainer component={Paper} className="table table-bordered">
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>ID Proceso</StyledTableCell>
                  <StyledTableCell align="left">
                    Nombre del Proceso
                  </StyledTableCell>
                  <StyledTableCell align="left">Macroproceso</StyledTableCell>
                  <StyledTableCell align="left">Subproceso</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowsP.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {row.idsubproceso}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.proceso}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.macroproceso}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {row.subproceso}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Row> */}

      </Form >
    </>
  );
};

export default NuevosActivos;
